import React from 'react';

import PageHeader from '../components/header/page';
import ContentBlock from '../components/contentblock';
import ABBlock from '../components/contentblock/abblock';
import SidebarNav from '../components/navigation/sidebar';

import Mrt from '../resources/images/devices/discovery.jpg';
import Mrt2x from '../resources/images/devices/discovery@2x.jpg';

import Us from '../resources/images/devices/logiq.jpg';
import Us2x from '../resources/images/devices/logiq@2x.jpg';

import Mammo from '../resources/images/devices/senograph.jpg';
import Mammo2x from '../resources/images/devices/senograph@2x.jpg';

import Digi from '../resources/images/devices/roentgen.jpg';
import Digi2x from '../resources/images/devices/roentgen@2x.jpg';

import Dexa from '../resources/images/devices/lunar.jpg';
import Dexa2x from '../resources/images/devices/lunar@2x.jpg';

import Ct from '../resources/images/devices/lunar.jpg';
import Ct2x from '../resources/images/devices/lunar@2x.jpg';

const ServicesPage = props =>
  (<main>
    <PageHeader headline="Unsere Untersuchungen"/>
    <section className="container-custom split">
      <ContentBlock title="Für alle unsere Untersuchungen bitten wir Sie, Folgendes zu beachten:">
        <ul className="feature-list">
          <li>
            Bringen Sie zu Ihrem Termin <strong>den Ausweis, den Überweisungsschein</strong> und die <strong>E-card</strong> mit.
          </li>
          <li>
            Falls weder Deutsch noch Englisch gesprochen wird, ist die Begleitung durch einen <strong>Dolmetscher</strong> erforderlich.
          </li>
          <li>
            Skelettröntgen, Lungen-/Thoraxröntgen und Schädelröntgen finden <strong>ohne</strong> Termin nach Voranmeldung statt.
          </li>
          <li>
            Unsere durchschnittliche Wartezeit für eine MR-Untersuchung für ASVG Versicherte entspricht den vertraglichen Vereinbarungen mit der Sozialversicherung.
          </li>
          <li>
            Für alle anderen Untersuchungen sind <strong>Terminvereinbarungen</strong> per E-Mail, Telefon oder persönlich in der Ordination nötig.
          </li>
        </ul>
        
      </ContentBlock>
      <aside className="sidebar">
        <SidebarNav />
      </aside>
    </section>
    <section className="container-custom">
      <div className="feature-grid">
          <ABBlock card img={Mrt} img2x={Mrt2x} link="/leistungen/mrt">
            <ContentBlock title="MRT" link="/leistungen/mrt">
              Die Abdomenbildgebung ist aufgrund der komplexen Anatomie eine anspruchs&shy;volle Untersuchung.
            </ContentBlock>
          </ABBlock>
          <ABBlock card img={Us} img2x={Us2x} link="/leistungen/ultraschall">
            <ContentBlock title="Ultraschall" link="/leistungen/ultraschall">
              Unter Ultraschall versteht man Schallwellen oberhalb der menschlichen Hörgrenze.
            </ContentBlock>
          </ABBlock>
          <ABBlock card img={Mammo} img2x={Mammo2x} link="/leistungen/mammographie">
            <ContentBlock title="Mammographie" link="/leistungen/mammographie">
              Die Mammographie ist eine spezielle Röntgenuntersuchung der Brust.
            </ContentBlock>
          </ABBlock>
          <ABBlock card img={Digi} img2x={Digi2x} link="/leistungen/roentgen">
            <ContentBlock title="Digitales Röntgen" link="/leistungen/roentgen">
              Unter digitalem Röntgen versteht man ein bildgebendes Verfahren.
            </ContentBlock>
          </ABBlock>
          <ABBlock card img={Dexa} img2x={Dexa2x} link="/leistungen/dexa">
            <ContentBlock title="DEXA" link="/leistungen/dexa">
              Als Knochendichtemessung, auch Dexamessung, werden medizinisch-technische Verfahren bezeichnet, die zur Bestimmung der Dichte bzw. des Kalksalzgehaltes des Knochens dienen.
            </ContentBlock>
          </ABBlock>
      </div>
    </section>
  </main>);

export default ServicesPage;


// WEBPACK FOOTER //
// ./src/pages/leistungen.js